<template>
  <div>
    <Modal
      :title="$t('global.advanced-auto-scaling')"
      @close="close"
      @confirm="confirm"
      :hide-footer="true"
    >
      <template #body>
        <SiteEnableAdvancedAutoScaleForm :plan="data.plan" :site="data.site" v-on="$listeners" />
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/display/Modal";
import SiteEnableAdvancedAutoScaleForm from "@/components/smart/forms/SiteEnableAdvancedAutoScaleForm";

export default {
  name: "SiteEnableAdvancedAutoScaleModal",
  props: {
    data: Object,
  },
  components: {
    Modal,
    SiteEnableAdvancedAutoScaleForm,
  },
  setup(props, { emit }) {
    const close = () => emit("close");
    const confirm = () => emit("confirm");

    return {
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
